export interface EmployeeData {
  id: number;
  userId: number;
  dateHired: Date;
  isNurse: boolean;
  isDoctor: boolean;
}

export const initialEmployeeData: EmployeeData = {
  id: 0,
  userId: 0,
  dateHired: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
  isNurse: false,
  isDoctor: false,
};
